import { BreadIcon } from '@/assets/icons';
import Link from 'next/link';
import React from 'react';

interface BreadCrumbProps {
  breadcrumbs: { name: string; link?: string; className?: string }[];
}

const BreadCrumb = ({ breadcrumbs }: BreadCrumbProps) => {
  return (
    <div className="no-scrollbar overflow-x-auto">
      <div className="text-small flex h-[35px] w-max items-center px-4">
        {breadcrumbs.map((item, index) => {
          return (
            <div
              key={index}
              className="flex flex-row items-center justify-center"
            >
              <div
                className={`text-PC-Caption-Medium ${item?.className} text-neutral-gray
                `}
              >
                <Link href={item?.link as string}>{item?.name}</Link>
              </div>
              {index < breadcrumbs.length - 1 && (
                <BreadIcon
                  className={`mx-2 w-[6px] ${index === 2 ? 'hidden' : ''}`}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BreadCrumb;
